<template>
    <el-dialog
        :title="processErrorLog.fileName"
        :visible.sync="show"
        @close="$emit('update:isVisible', false)"
        :close-on-click-modal="false"
        >{{ processErrorLog.content }}
    </el-dialog>
</template>

<script>
import TaskService from '../../services/TaskService'
import Helper from '../../utilities/Helper'

/**
 * @vue-data {Boolean} [show=this.isVisible] - Flag that indicates whether to show the modal
 */
export default {
    props: {
        isVisible: Boolean,
        recordSelected: Object,
    },
    watch: {
        isVisible(value) {
            this.show = value
        },
        recordSelected(value) {
            this.getErrorDetails(value.processErrorLogId)
        },
    },
    data() {
        return {
            show: this.isVisible,
            processErrorLog: {
                fileName: null,
                content: null,
            },
        }
    },
    methods: {
        handleError: Helper.handleError,
        async getErrorDetails(processErrorLogId) {
            const loading = this.$loading({
                lock: true,
                //text: "Working",
                background: 'rgba(0, 0, 0, 0.3)',
            })
            try {
                const results = await TaskService.getErrorLog({ processErrorLogId })
                this.processErrorLog = results.data.processErrorLog
            } catch (err) {
                this.handleError(err, this, this.instanceId)
            } finally {
                loading.close()
            }
        },
    },
}
</script>

<style scoped>
.button {
    background-color: #b3282d;
    color: white;
    border-color: white;
}
.button:focus {
    background-color: #9a0f14;
    color: white;
    border-color: white;
    outline: none;
}
.button:hover {
    background-color: #9a0f14;
    color: white;
    border-color: white;
    outline: none;
}
</style>
